import React from 'react';
import {
	BodyText,
	Divider,
	Flex,
	LayoutBox,
	StyledBoxV2,
} from '@bamboohr/fabric';

export const TextDivider: React.FC<{ text: string }> = ({ text }) => {
	return (
		<Flex
			alignItems="center"
			display="inline-flex"
			height="19px"
			marginY={3}
			position="relative"
			width="352px"
		>
			<LayoutBox width="100%">
				<Divider color="neutral-extra-weak" />
			</LayoutBox>
			<Flex justifyContent="center" position="absolute" width="100%">
				<StyledBoxV2 backgroundColor="neutral-forced-white" paddingX={1.25}>
					<BodyText color="neutral-weak" size="extra-small">
						{text}
					</BodyText>
				</StyledBoxV2>
			</Flex>
		</Flex>
	);
};
